export function hexToRgb(hex, opacity) {
    let _hex = hex.slice(1);
    let bigint = parseInt(_hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return r + "," + g + "," + b + "," + opacity;
}
